import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getTankersAWS, getTrucksAWS } from '../../services/fuelLevelService'
import { reloadDone } from '../../store/actions/screenActions'

export const FETCH_DATA_TRUCKS = 'FETCH_DATA_TRUCKS'
export const FETCH_DATA_TRUCKS_ERROR = 'FETCH_DATA_TRUCKS_ERROR'
export const FETCH_DATA_TRUCKS_SUCCESS = 'FETCH_DATA_TRUCKS_SUCCESS'
export const onFetchDataTrucks = makeActionCreator(FETCH_DATA_TRUCKS)
export const onFetchDataTrucksError = makeActionCreator(FETCH_DATA_TRUCKS_ERROR, 'payload')
export const onFetchDataTrucksSuccess = makeActionCreator(FETCH_DATA_TRUCKS_SUCCESS, 'payload')
export const onFetchDataTrucksThunk = () => async dispatch => {
  dispatch(onFetchDataTrucks())

  try {
    const trucks = await getTrucksAWS()
    const lowLevelGas = trucks.filter(truck => truck.percent < 20)
    const posibleError = lowLevelGas.length > 300

    return batch(() => {
      dispatch(
        onFetchDataTrucksSuccess({
          trucks,
          posibleError
        })
      )
      dispatch(reloadDone())
    })
  } catch (error) {
    return dispatch(onFetchDataTrucksError({ error }))
  }
}

export const FETCH_DATA_TANKERS = 'FETCH_DATA_TANKERS'
export const FETCH_DATA_TANKERS_ERROR = 'FETCH_DATA_TANKERS_ERROR'
export const FETCH_DATA_TANKERS_SUCCESS = 'FETCH_DATA_TANKERS_SUCCESS'
export const onFetchDataTankers = makeActionCreator(FETCH_DATA_TANKERS)
export const onFetchDataTankersError = makeActionCreator(FETCH_DATA_TANKERS_ERROR, 'payload')
export const onFetchDataTankersSuccess = makeActionCreator(FETCH_DATA_TANKERS_SUCCESS, 'payload')
export const onFetchDataTankersThunk = () => async dispatch => {
  dispatch(onFetchDataTankers())

  try {
    const trucks = await getTankersAWS()

    return batch(() => {
      dispatch(
        onFetchDataTankersSuccess({
          trucks
        })
      )
      dispatch(reloadDone())
    })
  } catch (error) {
    return dispatch(onFetchDataTankersError({ error }))
  }
}

export const REQUEST_FULL_SCREEN_SUCCESS = 'REQUEST_FULL_SCREEN_SUCCESS'
export const onRequestFullScreenSuccess = makeActionCreator(REQUEST_FULL_SCREEN_SUCCESS)

export const SALUD_TIMELINE_SUCCESS = 'SALUD_TIMELINE_SUCCESS'
export const onSaludTimelineSuccess = makeActionCreator(SALUD_TIMELINE_SUCCESS, 'payload')
